import type { ReactElement } from "react";
import { useOnline } from "../lib/network";
import { useTranslation } from "../i18n/useTranslation";
import styles from "./OfflineBanner.module.css";

export function OfflineBanner(): ReactElement | null {
  const { t } = useTranslation();
  const online = useOnline();
  if (online) return null;
  return (
    <div role="status" className={styles.banner}>
      {t("network.offline")}
    </div>
  );
}
